import * as _ from 'lodash';
import { useEffect, useState } from 'react';
import { IRecipient } from '@nkr/models/index';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Label } from 'react-bootstrap';

import 'react-bootstrap-typeahead/css/Typeahead.css';

interface IProps {
    recipientId: number,
    recipientList: IRecipient[],
    onSelected: (selected: number[]) => void
}

const SelectPatient = (props: IProps) => {
    useEffect(() => {
    }, [props.recipientId, props.recipientList])

    const handleChange = (newSelected: IRecipient[]) => {
        props.onSelected(newSelected.map(x => x.id));
    };

    const list = _.sortBy(props.recipientList, [(x) => x.lastName == '' ? 'x' : x.lastName, (x) => x.alias]);
    const selected = props.recipientList.filter(x => x.id == props.recipientId);

    return (
        <Typeahead
            id='select-patient'
            labelKey={(option) => {
                if (option.firstName != '' && option.lastName != '') {
                    return `${option.lastName}, ${option.firstName} (${option.alias})`;
                } else {
                    return option.alias;
                }
            }}
            filterBy={['firstName', 'lastName', 'alias']}
            options={list}
            selected={selected}
            paginate={false}
            clearButton={true}
            renderMenuItemChildren={(option, props) => {
                return (
                    <div>
                        {option.firstName != '' && option.lastName != '' ?
                            <div>{option.lastName}, {option.firstName} ({option.alias})</div>
                            :
                            <div><Label>name not specified</Label> ({option.alias})</div>
                        }
                    </div>
                );
            }}
            placeholder="Search by name or alias..."
            onChange={handleChange}
        />
    )
}

export default SelectPatient;